import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

interface DeleteTreatmentDialogProps {
  open: boolean;
  onClose: () => void;
  onDeleteSingle: () => void;
  onDeleteSeries: () => void;
  seriesSize: number;
}

const DeleteTreatmentDialog = ({
  open,
  onClose,
  onDeleteSingle,
  onDeleteSeries,
  seriesSize,
}: DeleteTreatmentDialogProps) => {
  const multiple = seriesSize > 1;

  const handleDeleteSingle = () => {
    onDeleteSingle();
    onClose();
  };

  const handleDeleteSeries = () => {
    onDeleteSeries();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete Treatment</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {multiple
            ? `This treatment is part of a series of ${seriesSize}. Delete just this treatment or the entire series?`
            : "Are you sure you want to delete this treatment?"}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        {multiple ? (
          <Button onClick={handleDeleteSingle}>Delete Treatment</Button>
        ) : null}
        {multiple ? (
          <Button color="error" onClick={handleDeleteSeries}>
            Delete Series
          </Button>
        ) : (
          <Button color="error" onClick={handleDeleteSingle}>
            Delete
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default DeleteTreatmentDialog;
